<div class="error-page">
  <div class="error-content">
    <!-- Illustration -->
    <div class="illustration">
      <svg class="illustration-svg" width="220" height="220" viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Outer dashed circle (slow rotate) -->
        <circle class="ring-outer" cx="110" cy="110" r="105" stroke="hsl(var(--primary) / 0.15)" stroke-width="1" stroke-dasharray="6 4" fill="none" />
        <!-- Middle dashed circle (slow rotate reverse) -->
        <circle class="ring-middle" cx="110" cy="110" r="85" stroke="hsl(var(--primary) / 0.12)" stroke-width="1" stroke-dasharray="4 4" fill="none" />
        <!-- Inner solid circle (pulse) -->
        <circle class="ring-inner" cx="110" cy="110" r="65" fill="hsl(var(--primary) / 0.06)" />
        <!-- Accent dot on outer ring -->
        <circle class="accent-dot" cx="148" cy="18" r="5" fill="hsl(var(--primary) / 0.2)" />

        <!-- Document icon -->
        <rect x="88" y="76" width="40" height="52" rx="4" stroke="hsl(var(--primary))" stroke-width="2.5" fill="none" />
        <!-- Document fold -->
        <path d="M116 76v12h12" stroke="hsl(var(--primary))" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
        <!-- Question mark on document -->
        <path d="M104 102c0-4 3-7 7-7s7 3 7 7c0 3-2 4-4 5s-3 2-3 4" stroke="hsl(var(--primary))" stroke-width="2.5" fill="none" stroke-linecap="round" />
        <circle cx="111" cy="117" r="1.5" fill="hsl(var(--primary))" />

        <!-- Magnifying glass badge -->
        <circle cx="138" cy="140" r="14" fill="hsl(var(--primary))" />
        <circle cx="136" cy="138" r="5" stroke="hsl(var(--card))" stroke-width="1.5" fill="none" />
        <line x1="140" y1="142" x2="144" y2="146" stroke="hsl(var(--card))" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    </div>

    <!-- Error badge -->
    <div class="error-badge error-badge--muted">
      {{ 'page_not_found_component.badge' | translate }}
    </div>

    <!-- Title -->
    <h1 class="error-title">
      {{ 'page_not_found_component.title' | translate }}
    </h1>

    <!-- Description -->
    <p class="error-description">
      {{ 'page_not_found_component.description' | translate }}
    </p>

    <!-- Back button -->
    <app-calio-flat-button
      type="primary"
      size="lg"
      enableRoutingHyperLink
      url="/"
      icon="arrow-left"
      buttonText="{{ 'page_not_found_component.back_to_dashboard' | translate }}"
    />
  </div>
</div>
